import { getScrollRestoreKey } from './scroll-restoration';

const positions = new Map<string, number>();

let scrollContainer: HTMLElement | null = null;

export function registerScrollContainer(el: HTMLElement | null) {
  scrollContainer = el;
}

export function rememberScrollPosition(pathname: string) {
  if (!scrollContainer) return;
  positions.set(getScrollRestoreKey(pathname), scrollContainer.scrollTop);
}

export function getRememberedScrollPosition(pathname: string) {
  return positions.get(getScrollRestoreKey(pathname)) ?? 0;
}

export function setRememberedScrollPosition(pathname: string, scrollTop: number) {
  positions.set(getScrollRestoreKey(pathname), scrollTop);
}
